import { paramToColumn } from '@/apps/crm/contacts/api/parameters'

export default {
  types(state) {
    let types = {}
    state.types.forEach(el => {
      types[el.id] = el
    })
    return types
  },
  // Get contact types by ID
  contactTypes(state) {
    if (!state.contactTypes) {
      return false
    }
    let types = {}
    state.contactTypes.forEach(el => {
      types[el.id] = el
    })
    return types
  },
  // Get attributes by ID
  attributes(state) {
    if (!state.attributes) {
      return false
    }
    let attributes = {}
    state.attributes.forEach(el => {
      attributes[el.id] = el
    })
    return attributes
  },
  // Table columns
  customColumns(state) {
    const attributes = state.attributes || []
    return attributes.map(p => {
      return paramToColumn(p)
    })
  },
  /**
   * Get type of a contact
   */
  getTypeById: (state, getters) => id => {
    let entity = { id: id, loaded: false }
    if (getters.types[id]) {
      entity = Object.assign({}, getters.types[id], { loaded: true })
    }
    return entity
  },
  getParamsById: state => id => {
    if (state.typeParams[id]) {
      return state.typeParams[id]
    }
    return false
  },
  getTypeWorksheetById: (state, getters) => id => {
    let entity = { id: id, loaded: false }
    if (getters.types[id]) {
      entity = Object.assign({}, getters.types[id], { loaded: true })
    }
    return entity
  }
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/store/common/getters.js